import { useCallback } from "react";
import { useAuth } from "./auth";
import { api } from "./api";

export function useStaffApi() {
  const { token, logout } = useAuth();
  return useCallback(
    async (method, url, data) => {
      try {
        const res = await api.request({ method, url, data, headers: { Authorization: `Bearer ${token}` } });
        return res.data;
      } catch (e) {
        if (e?.response?.status === 401) logout();
        throw e;
      }
    },
    [token, logout]
  );
}
